import LegalPageLayout from '../components/LegalPageLayout';

// NOTE: This is reasonable placeholder
// legal copy reflecting the actual data practices built into the
// platform (Cloudinary/PostgreSQL storage, manual payment tracking,
// WhatsApp notifications).

const sections = [
  {
    id: 'introduction',
    title: 'Introduction',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        This Privacy Policy explains how IASC Consultancy ("we", "us", "our") collects, uses, stores, and protects
        your personal information when you use our website, application portal, and consultancy services.
      </p>
    ),
  },
  {
    id: 'data-collected',
    title: 'Information We Collect',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">We collect information you provide directly, including:</p>
        <ul className="list-disc list-outside ml-6 mb-6 space-y-3 text-[#44474f]">
          <li>Personal details: full name, date of birth, nationality, gender, and contact information.</li>
          <li>Identity and travel documents: passport details, academic transcripts, and certificates.</li>
          <li>Application details: study or job preferences, work experience, and language proficiency.</li>
          <li>Payment records: proof-of-payment uploads and transaction details you submit for manual verification.</li>
        </ul>
      </>
    ),
  },
  {
    id: 'how-we-use',
    title: 'How We Use Your Information',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">Your information is used to:</p>
        <ul className="list-disc list-outside ml-6 mb-6 space-y-3 text-[#44474f]">
          <li>Process and track your study or job placement application.</li>
          <li>Communicate updates via your account portal and WhatsApp.</li>
          <li>Share necessary application details with partner universities, employers, and visa authorities.</li>
          <li>Generate official application documents once your application is approved.</li>
        </ul>
      </>
    ),
  },
  {
    id: 'sharing',
    title: 'Sharing of Information',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        We share your data only where necessary to progress your application — with the specific university,
        employer, or embassy/visa authority relevant to your submission. We do not sell your personal information
        to third parties for marketing purposes.
      </p>
    ),
  },
  {
    id: 'storage',
    title: 'Data Storage & Security',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        Application records are stored in a secured database, and uploaded documents (passports, transcripts,
        certificates) are stored via encrypted cloud storage. Access to your records is restricted to your
        assigned agent and platform administrators.
      </p>
    ),
  },
  {
    id: 'retention',
    title: 'Data Retention',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        We retain your personal data for as long as your application is active, and for a reasonable period
        afterward for record-keeping and legal compliance. You may request deletion of your data by contacting us
        directly, subject to any ongoing legal or contractual obligations.
      </p>
    ),
  },
  {
    id: 'your-rights',
    title: 'Your Rights',
    content: (
      <>
        <p className="text-[#44474f] mb-6 leading-relaxed">You have the right to:</p>
        <ul className="list-disc list-outside ml-6 mb-6 space-y-3 text-[#44474f]">
          <li>Access the personal data we hold about you.</li>
          <li>Request corrections to inaccurate information.</li>
          <li>Request deletion of your data, subject to legal retention requirements.</li>
          <li>Withdraw consent for communications at any time.</li>
        </ul>
      </>
    ),
  },
  {
    id: 'contact',
    title: 'Contact Us',
    content: (
      <p className="text-[#44474f] mb-6 leading-relaxed">
        For any privacy-related questions or requests, please contact us at{' '}
        <a href="mailto:agentzw@iascupdate.com" className="text-[#00255a] font-semibold hover:underline">
          agentzw@iascupdate.com
        </a>{' '}
        or via WhatsApp at +263 77 582 7371.
      </p>
    ),
  },
];

export default function PrivacyPage() {
  return <LegalPageLayout title="Privacy Policy" lastUpdated="August 06, 2026" sections={sections} />;
}